import { Link } from "react-router-dom";
import { useReveal } from "../lib/useReveal";
import { Quote } from "lucide-react";

const STORIES = [
  {
    hook: "I came back to school when the bathrooms worked. That is the whole story.",
    voice: "Student",
    tag: "Halegere Village School",
    accent: "coral",
  },
  {
    hook: "I used to teach four grades in one room. Now each grade has its own teacher and dignity.",
    voice: "Teacher",
    tag: "Besagara Halli Village School",
    accent: "teal",
  },
  {
    hook: "My daughter opens the computer with the same confidence a city child does. That is worth everything.",
    voice: "Parent",
    tag: "Naganayakanahalli Village School",
    accent: "sunflower",
  },
];

const ACCENT = {
  coral: { chip: "bg-coral text-white", quote: "text-coral", bar: "bg-coral" },
  teal: { chip: "bg-teal text-white", quote: "text-teal", bar: "bg-teal" },
  sunflower: { chip: "bg-sunflower text-navy", quote: "text-sunflower-dark", bar: "bg-sunflower" },
};

export default function Stories() {
  const ref = useReveal();

  return (
    <section id="stories" data-testid="stories-section" className="relative py-16 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 items-center">
          <div className="max-w-2xl text-center md:text-left">
            <span className="section-chip">Impact</span>
            <h2 className="mt-4 font-display font-extrabold text-navy text-3xl sm:text-4xl md:text-6xl leading-[1.05] tracking-tight">
              Stories of <em>Change.</em>
            </h2>
            <p className="mt-4 text-navy/75 font-display text-base md:text-lg leading-relaxed">
              Early sketches from the schools we work in — the fuller telling still to come. What the
              students, teachers and parents say, in their own words.
            </p>
          </div>
          <Link to="/get-involved#donate" className="btn-outline-indigo shrink-0" data-testid="stories-cta">Help us write more</Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STORIES.map((s, i) => {
            const a = ACCENT[s.accent];
            return (
              <article
                key={i}
                data-testid={`story-card-${i}`}
                className="manuscript-card group relative overflow-hidden flex flex-col"
              >
                <span className={`absolute top-0 left-0 h-full w-1 ${a.bar}`} aria-hidden />
                <div className={`inline-flex self-start items-center gap-2 px-3 py-1 rounded-sm text-[10px] font-display font-bold uppercase tracking-widest ${a.chip}`}>
                  In their words · {s.voice}
                </div>
                <Quote className={`w-10 h-10 ${a.quote} opacity-30 mt-6`} strokeWidth={1.5} />
                <blockquote className={`quote mt-3 text-navy text-xl md:text-2xl leading-snug not-italic`}>
                  &ldquo;{s.hook}&rdquo;
                </blockquote>
                <div className="mt-auto pt-6 dashed-divider flex items-center justify-between">
                  <div className="font-display text-xs text-navy/60 uppercase tracking-widest">
                    {s.tag}
                  </div>
                  <button className={`font-display font-bold text-xs uppercase tracking-widest ${a.quote} hover:underline`}>
                    Read More
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
